<div class="typeahead-search">
  <div class="input-wrapper" #anchor>
    <input
      type="text"
      class="search-text-field"
      [class.error]="error"
      [class.disabled]="disabled"
      [attr.id]="controlId"
      [disabled]="disabled"
      [value]="(searchText$ | async) ?? ''"
      [placeholder]="placeholder"
      autocomplete="off"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()" />
    <button
      *ngIf="((searchText$ | async)?.length ?? 0) > 0 && !disabled"
      type="button"
      class="close"
      aria-label="Clear search"
      i18n-aria-label
      (click)="clear()"></button>
  </div>

  <div class="dropdown-content" #dropdownContent [hidden]="!(showDropdown$ | async) || disabled">
    <ng-container *ngIf="filteredItems$ | async as items">
      <div
        *ngFor="let item of items; let i = index; trackBy: trackById"
        class="dropdown-item"
        [class.disabled]="item.getSelectionIsDisabled()"
        [class.highlighted]="i === highlightedIndex"
        [class.selected]="item.getSelectionValue() === (selectedItem$ | async)?.getSelectionValue()"
        (click)="selectItem(item)">
        {{ item.getSelectionTitle() }}
      </div>
      <div class="no-results" *ngIf="!items.length" i18n>No results found</div>
    </ng-container>
  </div>
</div>
